export class Motivo {

    public idCompania: string;
    public idMotivo: string;
    public descripcion: string;
}